import React from 'react';
import { connect } from 'react-redux';
import { Tab, TabPane } from 'semantic-ui-react';
import AssetAdminView from './AssetAdminView';
import CategoryView from '@components/assetAdmin/CategoryView';
import GameTitleView from '@components/assetAdmin/GameTitleView';
import ManufacturerView from '@components/assetAdmin/ManufacturerView';
import SupplierView from '@components/assetAdmin/SupplierView';
import CabinetTypeView from '@components/assetAdmin/CabinetTypeView';
import DepotView from '@components/assetAdmin/DepotView';
import NoteAcceptorView from '@components/assetAdmin/NoteAcceptorView';
import GameLibraryView from '@components/assetAdmin/GameLibraryView';

const AssetAdminViewContainer = (props) => {

    const { billValidatorDisplay } = props.login;

    const panes = [
        { menuItem: 'Asset', render: () => <TabPane><AssetAdminView /></TabPane> },
        { menuItem: 'Category', render: () => <TabPane><CategoryView /></TabPane> },
        { menuItem: 'Manufacturer', render: () => <TabPane><ManufacturerView /></TabPane> },
        { menuItem: 'Cabinet Type', render: () => <TabPane><CabinetTypeView /></TabPane> },
        { menuItem: 'Cabinet Title/Game Pack', render: () => <TabPane><GameTitleView /></TabPane> },
        { menuItem: 'Game Library', render: () => <TabPane><GameLibraryView /></TabPane> },
        { menuItem: 'Supplier', render: () => <TabPane><SupplierView /></TabPane> },
        { menuItem: 'Depot', render: () => <TabPane><DepotView /></TabPane> },
        { menuItem: billValidatorDisplay ? 'Bill Validator' : 'Note Acceptor', render: () => <TabPane><NoteAcceptorView /></TabPane> },
    ]


    return (
        <div className="flex-stretch gs-flex-container-vertical height-100">
            <Tab 
                panes={panes} 
                className="flex-stretch gs-flex-container-vertical height-100"
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        login: state.logIn,
    }
}

export default connect(mapStateToProps, {})(AssetAdminViewContainer);